import { storeCreator } from '@/utils/store/store.utils';

interface PayoutOrderModalsState {
  isAddServiceModalVisible: boolean;
  isClearAllModalVisible: boolean;
  isValidationTriggered: boolean;
  isSaved: boolean;
  openAddServiceModal: () => void;
  closeAddServiceModal: () => void;
  openClearAllModal: () => void;
  closeClearAllModal: () => void;
  setValidationTriggered: (value: boolean) => void;
  setIsSaved: (value: boolean) => void;
  reset: () => void;
}

const INITIAL_STATE = {
  isAddServiceModalVisible: false,
  isClearAllModalVisible: false,
  isValidationTriggered: false,
  isSaved: false,
};

export const usePayoutOrderModalsStore = storeCreator<PayoutOrderModalsState>((set) => ({
  ...INITIAL_STATE,
  openAddServiceModal: () => set({ isAddServiceModalVisible: true }),
  closeAddServiceModal: () => set({ isAddServiceModalVisible: false }),
  openClearAllModal: () => set({ isClearAllModalVisible: true }),
  closeClearAllModal: () => set({ isClearAllModalVisible: false }),
  setValidationTriggered: (value: boolean) => set({ isValidationTriggered: value }),
  setIsSaved: (value: boolean) => set({ isSaved: value }),
  reset: () => set(INITIAL_STATE),
}));
